// src/services/ebayService.js
// Service to handle eBay API calls

// URL should be configured for your environment
const EBAY_API_ENDPOINT = '/api/ebay'; // This will be proxied through your server

/**
 * Fetches eBay listings for a specific board game
 * @param {string} gameTitle - The title of the game to search for
 * @returns {Promise<Array>} Array of eBay listings
 */
export const fetchEbayListings = async (gameTitle) => {
  try {
    // In a real implementation, you'd call your backend API which handles eBay API authentication
    const response = await fetch(`${EBAY_API_ENDPOINT}/search?q=${encodeURIComponent(gameTitle + ' board game')}&limit=3`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch eBay listings');
    }

    const data = await response.json();
    return data.items || [];
  } catch (error) {
    console.error('Error fetching eBay listings:', error);
    throw error;
  }
};